export const reduxKey = '@@UnreadChats';
